import { Component } from '@angular/core';

@Component({
  selector: 'admin-dashboard-frontend-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'admin-dashboard-frontend';
  sidebarExpanded = true;
}
